// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/sparkles.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/sparkles'

import { Icon, type IconComponentProps } from '../icon'

export const SparklesIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
